module.exports = {"id":"215018","name":"Brahian Alemán","rating":"74","photo":"./data/images/photos/2/215018.png","club":{"name":"G. La Plata","logo":"./data/images/clubs/G.LaPlata.png"},"positions":["MG","MC","MOC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BrahianAleman0.json
// module id = 636
// module chunks = 0